export default "<template>\n    <slot></slot>\n    <span id=\"arrow-down-icon\" class=\"arrow-down-icon\"></span>\n</template>\n";